export const operationDirection = {
    in: 'In',
    out: 'Out',
    internal: 'Internal',
};